import { render, staticRenderFns } from "./QRcodePage.vue?vue&type=template&id=0ea55c6c&scoped=true"
import script from "./QRcodePage.vue?vue&type=script&lang=ts"
export * from "./QRcodePage.vue?vue&type=script&lang=ts"
import style0 from "./QRcodePage.vue?vue&type=style&index=0&id=0ea55c6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea55c6c",
  null
  
)

export default component.exports